if (!customElements.get("product-handling")) {
  class ProductHandling extends HTMLElement {
    // Static property to track if event listeners have been added
    static eventListenersAdded = false;

    constructor() {
      super();
      this.activeTimer = null;
      this.dailyUpdateTimer = null;
      this.latestCountdownId = null;
      this.bankHolidays = []; // Initialize as empty array
      this.debouncedHandlingGenerate = this.createDebouncedHandlingGenerate();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    createDebouncedHandlingGenerate() {
      let timeout;
      return (variantId, handling, timeBased, cutoffTime, warehouse, available, curQty, template) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.handlingGenerate(
            variantId,
            handling,
            timeBased,
            cutoffTime,
            warehouse,
            available,
            curQty,
            template
          );
        }, 100);
      };
    }

    async initLazySection() {
      this.handlingNotice = this.querySelector(".js-handling-notice");
      this.handlingBadge = this.querySelector(".js-handling-badge");
      if (!this.handlingNotice) {
        console.warn(
          "Handling notice element (.js-handling-notice) not found."
        );
      }

      // Determine if this instance is in a modal

      this.isModal = !!this.closest(".quick-add-drawer");

      this.latestCountdownId = this.isModal
        ? `modal-${this.dataset.productId}`
        : `product-page-${this.dataset.productId}`;

      this.variantInventory = this.getVariantInventory();
      this.bankHolidays = await this.getBankHolidays();
      console.log(this.bankHolidays);
      this.curQty = 1;

	      this.updateInventory();

      // Check the initial variant availability
      const initialVariant = this.variantInventory.find(
        (variant) => variant.id == this.dataset.id
      );

      if (
        !initialVariant ||
        !initialVariant.available ||
        initialVariant.handling == -1
      ) {
        this.hidden = true;
        this.toggleBadge(false);
      } else {
        this.hidden = false;
      }



      this.setUpQtyPicker();
      this.addGlobalEventListeners();
      this.scheduleDailyUpdate(); // Schedule the daily inventory update
    }

    scheduleDailyUpdate() {
      if (this.dailyUpdateTimer) {
        clearTimeout(this.dailyUpdateTimer);
      }

      const now = this.getUKDate();

  // Use the same date as 'now' for 'nextUpdate'
  const nextUpdate = new Date(now);
  const [cutoffHour, cutoffMinute] = this.parseCutoffTime(this.currentCutoffTime);
  nextUpdate.setHours(cutoffHour, cutoffMinute, 0, 0);

      if (now >= nextUpdate) {
        nextUpdate.setDate(nextUpdate.getDate() + 1);
      }

  let timeUntilNextUpdate = nextUpdate - now;

  // Ensure 'timeUntilNextUpdate' is positive
  if (timeUntilNextUpdate <= 0) {
    timeUntilNextUpdate = 1000; // Set a default delay (e.g., 1 second)
  }

  // Schedule the update
      this.dailyUpdateTimer = setTimeout(() => {
        this.dailyUpdateTimer = null;
        this.updateInventory();
        this.scheduleDailyUpdate(); // Reschedule for the next day
      }, timeUntilNextUpdate);
    }


    updateInventory() {
      const matchingVariant = this.variantInventory.find(
        (variant) => variant.id == this.dataset.id && variant.handling != -1
      );

      this.inventory = matchingVariant;

      if (matchingVariant) {
        this.currentCutoffTime = matchingVariant.cutoff_time || "14:00";
        this.debouncedHandlingGenerate(
          matchingVariant.id,
          matchingVariant.handling,
          matchingVariant.time_based,
          matchingVariant.cutoff_time,
          matchingVariant.warehouse,
          matchingVariant.available,
          this.curQty,
          matchingVariant.template
        );
      } else {
        this.currentCutoffTime = "14:00";
        this.toggleBadge(false);
        // If no matching variant is found, pass default values
        this.debouncedHandlingGenerate(
          null,
          null,
          true,
          "14:00",
          null,
          false,
          this.curQty,
          null
        );
      }
    }

    setUpQtyPicker() {
      const qtyPicker =
        this.closest(".product-info")?.querySelector("quantity-input");
      if (qtyPicker) {
        const inputField = qtyPicker.querySelector(".qty-input__input");
        const minusButton = qtyPicker.querySelector(".btn--minus");
        const plusButton = qtyPicker.querySelector(".btn--plus");
        minusButton.addEventListener("click", () =>
          this.handleButtonUpdate(inputField, -1)
        );
        plusButton.addEventListener("click", () =>
          this.handleButtonUpdate(inputField, 1)
        );
      }
    }

    addGlobalEventListeners() {
      if (ProductHandling.eventListenersAdded) {
        return;
      }
      ProductHandling.eventListenersAdded = true;

      document.addEventListener("on:quickbuy:after-open", () => {
        // When the modal is opened, stop the countdown on the product page
        const productPageElement = document.querySelector(
          "product-handling:not(quick-add-drawer product-handling)"
        );
        if (productPageElement && !productPageElement.isModal) {
          productPageElement.handleModalOpen();
        }
      });

      document.addEventListener("on:quickbuy:after-close", () => {
        // When the modal is closed, resume the countdown on the product page
        const productPageElement = document.querySelector(
          "product-handling:not(quick-add-drawer product-handling)"
        );
        if (productPageElement && !productPageElement.isModal) {
          productPageElement.handleModalClose();
        }
      });

      // Existing event listeners for modal instance
      document.addEventListener("on:quickbuy:after-open", (event) => {
        const quickAddDrawer = event.target.closest("quick-add-drawer");
        if (!quickAddDrawer) {
          console.warn("quick-add-drawer not found");
          return;
        }

        const productElement = quickAddDrawer.querySelector("product-handling");
        if (productElement) {
          productElement.handleQuickbuyOpen();
        } else {
          console.warn(
            "No product-handling element found inside quick-add-drawer."
          );
        }
      });

      document.addEventListener("on:quickbuy:after-close", (event) => {
        const quickAddDrawer = event.target.closest("quick-add-drawer");
        if (!quickAddDrawer) {
          console.warn("quick-add-drawer not found");
          return;
        }

        const productElement = quickAddDrawer.querySelector("product-handling");
        if (productElement) {
          productElement.handleQuickbuyClose();
        } else {
          console.warn(
            "No product-handling element found inside quick-add-drawer."
          );
        }
      });
    }

    handleQuickbuyOpen() {
      
      const countdownId = `modal-${this.dataset.productId}`;

      // Stop any existing countdown
      this.stopCountdown();

      this.latestCountdownId = countdownId;

      setTimeout(() => {
        this.handlingNotice = this.querySelector(".js-handling-notice");

        if (!this.handlingNotice) {
          console.warn("Modal handling notice element not found.");
          return;
        }

        this.startCountdown(countdownId);
      }, 100); // Delay ensures modal DOM is ready
    }

    handleQuickbuyClose() {

      if (this.isModal) {
        this.stopCountdown();
      } else {
        this.latestCountdownId = `product-page-${this.dataset.productId}`;
        this.handlingNotice = this.querySelector(".js-handling-notice");
        if (this.handlingNotice) {
          this.startCountdown(this.latestCountdownId);
          this.updateInventory();
        } else {
          console.warn("Handling notice not found on product page.");
        }
      }
    }


    cartAndLineItemChangeListener(event) {
      this.inventory = this.variantInventory.find(
        (variant) => variant.id === event.detail.variantId
      );
      if (this.inventory && this.inventory.handling != -1) {
        this.handlingGenerate(
          this.inventory.id,
          this.inventory.handling,
          this.inventory.time_based,
          this.inventory.cutoff_time,
          this.inventory.warehouse,
          this.inventory.available,
          this.curQty,
          this.inventory.template
        );
      }
    }

    handleButtonUpdate(inputField, change) {
      const currentValue = parseInt(inputField.value, 10) || 0;
      this.curQty = currentValue + change;
      if (this.inventory && this.inventory.handling != -1) {
        this.handlingGenerate(
          this.inventory.id,
          this.inventory.handling,
          this.inventory.time_based,
          this.inventory.cutoff_time,
          this.inventory.warehouse,
          this.inventory.available,
          this.curQty,
          this.inventory.template
        );
      }
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    // Update getBankHolidays to fetch data from the URL
async getBankHolidays() {
  try {
    // Fetch bank holidays from gov.uk
    const response = await fetch('https://www.gov.uk/bank-holidays.json');
    const data = await response.json();
    const events = data['england-and-wales'].events;
    const dates = events.map(event => event.date);

    // Fetch additional non-working dates from Shopify
    const additionalResponse = await fetch('https://cdn.shopify.com/s/files/1/2728/6638/files/gsl-non-working-days.json');
    const additionalData = await additionalResponse.json();
    const additionalDates = additionalData.dates;

    // Combine both sets of dates
    const allDates = [...dates, ...additionalDates];

    return allDates;
  } catch (error) {
    console.error("Error fetching bank holidays or additional dates: ", error);
    return [];
  }
}

    connectedCallback() {
      this.addEventListener(
        "variantChange",
        this.handleVariantChange.bind(this)
      );

      if (!this.isModal) {
        // This is the product-handling element on the product page
        document.addEventListener(
          "on:quickbuy:after-open",
          this.handleModalOpen.bind(this)
        );
        document.addEventListener(
          "on:quickbuy:after-close",
          this.handleModalClose.bind(this)
        );
      }
    }

	    disconnectedCallback() {
	      this.stopCountdown(); // Stop the countdown when the element is removed
	      if (this.dailyUpdateTimer) {
	        clearTimeout(this.dailyUpdateTimer);
	        this.dailyUpdateTimer = null;
	      }
	    }

    handleModalOpen() {
      this.stopCountdown();
    }

    handleModalClose() {
      this.latestCountdownId = `product-page-${this.dataset.productId}`;
      this.startCountdown(this.latestCountdownId);
      this.updateInventory();
    }

    handleVariantChange(evt) {
      this.dataset.id = evt.detail.variant.id;

      // Trigger inventory update only if a new variant is selected
      if (this.inventory?.id !== evt.detail.variant.id) {
        this.updateInventory(); // Handles debouncing
      }

      if (evt.detail.variant && evt.detail.variant.available == true) {
        this.inventory = this.variantInventory.find(
          (variant) => variant.id === evt.detail.variant.id
        );

        if (this.inventory && this.inventory.handling != -1) {
          this.hidden = false;
        } else {
          this.hidden = true;
          this.toggleBadge(false);
        }
      } else {
        this.hidden = true;
        this.toggleBadge(false);
      }
    }

    toggleBadge(show) {
      if (!this.handlingBadge) return;
      this.handlingBadge.hidden = !show;
      if (show && !this.handlingBadge.textContent.trim()) {
        this.handlingBadge.textContent = this.dataset.badgeLabel || theme.strings.quickDespatch || "Quick Despatch";
      }
    }


startCountdown(id) {
  if (this.activeTimer) {
    clearTimeout(this.activeTimer);
  }

  this.latestCountdownId = id; // Set the latest countdown ID
  this.updateCountdown(id); // Start the countdown immediately
}

    stopCountdown() {
      if (this.activeTimer) {
        clearInterval(this.activeTimer);
        this.activeTimer = null;
      } else {
        console.warn(
          `No active timer found to stop for "${this.latestCountdownId}".`
        );
      }
    }

updateCountdown(id) {
  if (this.latestCountdownId !== id) {
    console.warn(
      `Skipping countdown update for inactive or stopped context "${id}".`
    );
    this.stopCountdown(); // Extra safety to clear lingering intervals
    return;
  }
  if (!this.handlingNotice) {
    console.warn(
      "Handling notice is not defined; cannot update countdown."
    );
    return;
  }

  const countdownElement = this.handlingNotice.querySelector(
    `.countdown-timer[data-id="${id}"]`
  );

  if (!countdownElement) {
    console.warn(`Countdown element for "${id}" not found.`);
    return;
  }

  const now = this.getUKDate();
  const targetTime = this.calculateTargetTime(now, this.currentCutoffTime);
  const timeDiff = targetTime - now;

  if (timeDiff <= 0) {
    countdownElement.innerHTML = "Time expired";
    this.stopCountdown();
    return;
  }

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);


  let countdownText = '';

  if (days > 0) {
    countdownText = `${days}d ${hours}h ${minutes}m`;
  } else if (hours > 0) {
    countdownText = `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    if (timeDiff <= 120000) {
      // Less than 2 minutes, show minutes and seconds
      countdownText = `${minutes}m ${seconds}s`;
    } else {
      countdownText = `${minutes}m`;
    }
  } else {
    // Less than a minute remains
    countdownText = `${seconds}s`;
  }

  countdownElement.innerHTML = countdownText;

  // Determine the next update frequency
  let updateFrequency = 30000; // Default to 30 seconds

  if (timeDiff <= 120000) {
    updateFrequency = 1000; // Update every second if less than 2 minutes remain
  }

  // Schedule the next update
  this.activeTimer = setTimeout(() => {
    this.updateCountdown(id);
  }, updateFrequency);
}


    /**
	     * Calculate the next target cutoff time on business days.
     * @param {Date} now - The current date and time.
     * @returns {Date} - The next target time.
     */
parseCutoffTime(cutoffTime) {
  const match = String(cutoffTime || "14:00").match(/^(\d{1,2})(?::(\d{2}))?(?::\d{2})?$/);
  if (!match) return [14, 0];

  const hour = Math.min(Math.max(parseInt(match[1], 10), 0), 23);
  const minute = Math.min(Math.max(parseInt(match[2] || "0", 10), 0), 59);
  return [hour, minute];
}

calculateTargetTime(now, cutoffTime = "14:00") {

  const [cutoffHour, cutoffMinute] = this.parseCutoffTime(cutoffTime);
  const targetTime = new Date(now);
  targetTime.setHours(cutoffHour, cutoffMinute, 0, 0);

  // If current time is past 2 PM UTC, move to next day
  if (now >= targetTime) {
    targetTime.setUTCDate(targetTime.getUTCDate() + 1);
  }

  // Loop until targetTime is not on a weekend or bank holiday
  while (this.isWeekendOrBankHoliday(targetTime)) {
    targetTime.setUTCDate(targetTime.getUTCDate() + 1);
  }

  return targetTime;
}



async handlingGenerate(
  variantId,
  handling,
  timeBased,
  cutoffTime,
  warehouse,
  available,
  curQty,
  template
) {
  
  if (!this.handlingNotice) {
    console.error(
      `Handling notice not found for "${this.latestCountdownId}".`
    );
    return;
  }

  if (!available) {
    this.handlingNotice.innerHTML = "";
    this.toggleBadge(false);
    this.stopCountdown();
    return;
  }

	  const id = this.isModal
	    ? `modal-${this.dataset.productId}`
	    : `product-page-${this.dataset.productId}`;
	  const usesCutoff = timeBased !== false;
	  const defaultCutoffTime = cutoffTime || "14:00";

	  try {
	    const response = await fetch("/cart.js");
	    const cart = await response.json();
	    const variantInCart = cart.items.find((item) => item.id === variantId);
	    let cartQuantity = variantInCart ? variantInCart.quantity : 0;
	    const canQuickDespatch = warehouse > 0 && warehouse > cartQuantity && warehouse >= curQty;
	    this.currentCutoffTime = canQuickDespatch ? "16:00" : defaultCutoffTime;

	    const now = this.getUKDate();

	    // Calculate cutoff time today.
	    const [cutoffHour, cutoffMinute] = this.parseCutoffTime(this.currentCutoffTime);
	    const cutoffTimeToday = new Date(now);
	    cutoffTimeToday.setHours(cutoffHour, cutoffMinute, 0, 0);

	    const isPastTargetTime = now >= cutoffTimeToday;
	    const isWeekendOrHoliday = this.isWeekendOrBankHoliday(now);

	    // Ensure minimum handling time is 0.
	    let adjustedHandling = handling >= 0 ? handling : 2;

	    if (usesCutoff && (isPastTargetTime || isWeekendOrHoliday)) {
	      adjustedHandling += 1;
	    }

	    let fromDay, toDay;

	    // Only allow immediate dispatch on real business days before cutoff.
	    if (!usesCutoff) {
	      fromDay = this.BusinessDays(now, 1);
	      toDay = this.BusinessDays(now, 2);
	    } else if (!isWeekendOrHoliday && !isPastTargetTime) {
	      fromDay = theme.strings.immediateHandling;
	      toDay = this.BusinessDays(now, 2);
	    } else if (isWeekendOrHoliday) {
	      fromDay = this.BusinessDays(now, 1);
	      toDay = this.BusinessDays(now, 2);
	    } else {
	      fromDay = this.BusinessDays(now, 2);
	      toDay = this.BusinessDays(now, 3);
	    }

	    let action = template !== "default" ? "collect" : "delivery";

	    let message;

	    if (canQuickDespatch) {
	      const fromDayText = `<span class='handlingFrom' style='font-weight:bold'>${fromDay}</span>`;
	      const toDayText = `<span class='handlingTo' style='font-weight:bold'>${toDay}</span>`;
	      const countdownTimer = `<span class='countdown-timer' data-id="${this.latestCountdownId}"></span>`;

	      message = usesCutoff
	        ? `Order within ${countdownTimer} for ${action} between ${fromDayText} - ${toDayText}`
	        : `Estimated ${action} between ${fromDayText} - ${toDayText}`;
	    } else {
	      // Recalculate handlingStart and handlingEnd based on adjustedHandling
	      const handlingStart = this.BusinessDays(now, adjustedHandling + 1);
	      const handlingEnd = this.BusinessDays(now, adjustedHandling + 2);

	      const fromDayText = `<span class='handlingFrom' style='font-weight:bold'>${handlingStart}</span>`;
	      const toDayText = `<span class='handlingTo' style='font-weight:bold'>${handlingEnd}</span>`;
	      const countdownTimer = `<span class='countdown-timer' data-id="${this.latestCountdownId}"></span>`;

	      message = usesCutoff
	        ? `Order within ${countdownTimer} for ${action} between ${fromDayText} - ${toDayText}`
	        : `Estimated ${action} between ${fromDayText} - ${toDayText}`;
	    }

	    this.toggleBadge(canQuickDespatch);
	    this.handlingNotice.innerHTML = message;
	    if (usesCutoff) {
	      this.startCountdown(id);
	      this.scheduleDailyUpdate();
	    }
	  } catch (error) {
	    this.toggleBadge(false);
	    console.error("Error:", error);
	  }
}



isWeekendOrBankHoliday(date) {
  const day = date.getDay();
  if (day === 0 || day === 6) {
    return true; // Weekend
  }
const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
const formattedDate = adjustedDate.toISOString().split('T')[0];

  if (!this.bankHolidays || this.bankHolidays.length === 0) {
    console.warn('Bank holidays not initialized yet.');
    return false; // Assume it's not a bank holiday
  }

  return this.bankHolidays.includes(formattedDate);
}

isSundayOrBankHoliday(date) {
  const day = date.getDay();
  if (day === 0) {
    return true; // Weekend
  }
const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
const formattedDate = adjustedDate.toISOString().split('T')[0];

  if (!this.bankHolidays || this.bankHolidays.length === 0) {
    console.warn('Bank holidays not initialized yet.');
    return false; // Assume it's not a bank holiday
  }

  return this.bankHolidays.includes(formattedDate);
}    



BusinessDays(d, n) {
  let date = new Date(d.getFullYear(), d.getMonth(), d.getDate()); // Local date components
  const formattedBankHolidays = new Set(this.bankHolidays);

  // If the current date is a weekend or bank holiday, find the next business day
  while (this.isWeekendOrBankHoliday(date)) {
    date.setDate(date.getDate() + 1);
  }

  let daysAdded = 0;
  while (daysAdded < n) {
    date.setDate(date.getDate() + 1);
    if (this.isWeekendOrBankHoliday(date)) {
      continue; // Skip weekends and bank holidays
    }
    daysAdded++;
  }


  if (Shopify.country !== "GB") {
    let additionalDays = 3;
    while (additionalDays > 0) {
      date.setDate(date.getDate() + 1);
      if (!this.isWeekendOrBankHoliday(date)) {
        additionalDays--;
      }
    }
  }

  // Format and return the date
  const localeFormat = Shopify.locale + "-" + Shopify.country;
  const options = { weekday: "short", day: "numeric", month: "short" };
  let formattedDate = date.toLocaleDateString(localeFormat, options);

  return formattedDate;
}




getUKDate() {

  const now = new Date();
  const options = {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  const formatter = new Intl.DateTimeFormat("en-GB", options);
  const [
    { value: day },
    ,
    { value: month },
    ,
    { value: year },
    ,
    { value: hour },
    ,
    { value: minute },
    ,
    { value: second },
  ] = formatter.formatToParts(now);

  // Create a date string in ISO 8601 format
  const ukDateString = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

  // Parse the date string into a Date object in UK time zone
  return new Date(ukDateString);
  
}

    
  }

  customElements.define("product-handling", ProductHandling);
}
